import React from 'react';

import DocumentsTable from '../../shared/DocumentsTable/DocumentsTable';

export default function DocumentsForPractice() {
  const options = {
    enableDocumentEdit: false,
    enableDocumentMarkup: false,
    enableDocumentSharing: false,
    enableAppointmentLinking: false,
    showImportantDocuments: false,
    showSendPatientForms: false,
    isPatient: true
  };

  return (
    <div className="h-full">
      <DocumentsTable level="chart" options={options} />
    </div>
  );
}
